import React from 'react';
import CountUp from 'react-countup';


type TankLevelDisplayProps = {
  percentage: number;
  label?: string;
  size?: 'small' | 'large';
  showCountUp?: boolean;
}

const getTankLevelClass = (percentage: number) => {
  if (percentage >= 75) return 'tank-level-high';
  if (percentage >= 25) return 'tank-level-medium';
  return 'tank-level-low';
};

export const TankLevelDisplay = (props: TankLevelDisplayProps) => {
  const displayAmount = props.percentage;
  const showCountUp = props.showCountUp ?? false;
  const topClass = displayAmount < 96 && displayAmount > 0 ? 'wave-top' : 'rounded-top';

  return <div className="row d-flex justify-content-center">
    <div className='w-75'>
      <div className={`rounded border ${getTankLevelClass(displayAmount)} border-3 position-relative`}>
        <h3 className="w-auto position-absolute top-50 start-50 translate-middle" style={{ zIndex: 1 }}>
          {showCountUp
            ? (<CountUp
              end={displayAmount}
              suffix="%"
              duration={0.5}
              redraw={false}
              preserveValue={true} />
            )
            : `${displayAmount}%`
          }
        </h3>
        <div className="progress-vertical w-100 rounded bg-light border border-light border-1" style={{ height: '4rem' }}>
          <div
            className={`${topClass} ${getTankLevelClass(displayAmount)} bg-gradient rounded-bottom`}
            role="progressbar"
            data-testid="tank-level-bar"
            style={{ height: (displayAmount > 2 && displayAmount < 90 ? displayAmount + 8 : displayAmount).toString() + '%' }} />
        </div>
      </div>
    </div>
    {
      props.label &&
      <div className="row px-1 d-flex justify-content-center">
        <p className="line-clamp line-clamp-1 mb-0 w-auto" style={{ fontSize: "13px" }}>{props.label}</p>
      </div>
    }
  </div>
};
